import React from "react";
import { useDispatch, useSelector } from "react-redux";

import userType from "../../../redux/actions/user/userType";
import { SideBarLinks } from "../../../utility/content/users/sideBarLinks";

import SideBarProfileComponent from "../../../components/private/sideBar";

import { ContainerSidebar } from "./styledSideBarProfileContainer";

const SideBarProfileContainer = () => {
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.userDetail);
  const userName =
    userDetail?.userDetail[0]?.first_name +
    " " +
    userDetail?.userDetail[0]?.last_name;
  const userImage = userDetail?.userDetail[0]?.usermeta?.img_addr;
  const userWallet = userDetail?.userDetail[0]?.usermeta?.balance?.toLocaleString()
  const userPoints = userDetail?.userDetail[0]?.usermeta?.points?.toLocaleString()
  const handleExit = () => {
    dispatch({ type: userType.SET_LOGOUT_USER });
  };
  return (
    <ContainerSidebar className="col-12 col-sm-3">
      <SideBarProfileComponent
        links={SideBarLinks}
        userName={userName}
        userImage={userImage}
        userWallet={userWallet}
        userPoints={userPoints}
        handleExit={handleExit}
      />
    </ContainerSidebar>
  );
};

export default SideBarProfileContainer;
